<div class="background">
    <div class="container">
        <header>
            <img src="../../../assets/images/logo.svg" alt="Customer Portal">
            <h2>{{'app.copyright' | translate}} <a href="https://mogree.com" target="_blank">mogree</a></h2>
        </header>
        <app-card></app-card>
    </div>
</div>
<app-footer></app-footer>